<div class="dcp">
    <div class="header">
        <h2>Are you sure, you want to cancel this order?</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" (click)="closeDialog()" [disabled]="isLoading" mat-dialog-close>Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="isLoading"
                (click)="cancelReqOrder()">{{isLoading ? 'Canceling...' : 'Confirm'}}</button>
        </div>
    </div>
</div>